import React, { useState } from "react";
import "../../../css/Form.css";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
// import ImagesPopup from '../../../helper/ImagesPopup';
import ERPUtils from "../../../helper/Utils";
import UploadFile from "../../../helper/UploadFile";
import { toast } from "react-toastify";
const TenthComp = (props) => {
  const {
    EducationDetailsHandler,
    EducationDetailsSelectHandler,
    getBoardOrInstitueList,
    compData,
    addComponent,
    EducationalDetailsDropDownHandler,
    data,
    YearsDropDownData,
    requiredFields,
    EducationStatus,
    GenerateRemovePopup,
    // onFileChange,
    // imageRemoveHandler,
    // openImageInTab,
    isRequired,
    states,
    countries,
    checkDecimal,
    boardList,
    institutionList,
    userDetails,
    setUserDetails,
    UploadData,
    setSaveTheData,
  } = props;

  // const [openView, setOpenView] = useState({
  // 	popupOpen: false,
  // 	currentIndex: null
  // });
  const [isMandatory] = useState((data.isMandatory && requiredFields.eduReq) || (requiredFields.eduReq && isRequired));
  const NoOptionsMessage = (props) => {
    return <div className="custom-no-options-message">Type to add...</div>;
  };

  //UPLOAD COMPONENT DATA SETTING
  const uploadProcessCode = "EMPLOYEE_APP_EDN_" + data.qualificationLevelCode;
  const processCodeData = UploadData.filter((item) => item.uploadProcessCode === uploadProcessCode);

  // const popupHandler = (event) => {
  // 	var oldObj = { ...openView };
  // 	oldObj.popupOpen = true;
  // 	oldObj.currentIndex = event.target.id;
  // 	setOpenView(oldObj);
  // };

  // const ClosePopup = () => {
  // 	var oldObj = { ...openView };
  // 	oldObj.popupOpen = false;
  // 	setOpenView(oldObj);
  // };

  const getUploadData = (data, otherParams) => {
    let target = otherParams.parent;
    let id = otherParams.id;
    let newState = { ...userDetails };
    newState.EducationDetailsObj[target][id].Documents = data;
    setUserDetails(newState);
    setSaveTheData(true);
  };
  return (
    <div className="col">
      {compData.map((el, index) => {
        return (
          <div key={index} className="container">
            <div className="row p-1">
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel ">
                  {data.isMandatory || isRequired ? <span className="requiredText">* </span> : null}
                  Qualification
                </label>
                <input className="form-control z-depth-3" value={data.label} type="text" name="Qualification" id={index + "Qualification"} title="" readOnly />
              </div>
              {data.isStatusDisplay ? (
                <div className="col-md-4 col-lg-3 col-sm-6">
                  <label className="formRenderlabel ">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Status</label>
                  <Select
                    className={isMandatory && ERPUtils.isNullorWhiteSpace(el.Status) ? "invalidSelect z-depth-3" : "z-depth-3"}
                    value={el.Status}
                    onChange={(selected) => EducationalDetailsDropDownHandler(selected, index, "Status", "", "Status", "Percentage", data.value, true)}
                    options={EducationStatus}
                  />
                  {isMandatory && ERPUtils.isNullorWhiteSpace(el.Status) ? (
                    <p className="ValidationError">
                      <i className="fa fa-warning warningIcon" />
                      Status cannot be empty
                    </p>
                  ) : null}
                </div>
              ) : null}
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel ">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Course</label>
                <input
                  className={isMandatory && ERPUtils.isNullorWhiteSpace(el.Course) ? "form-control invalid z-depth-3" : "form-control z-depth-3"}
                  value={el.Course || ""}
                  type="text"
                  name="Course"
                  onChange={(event) => EducationDetailsHandler(event, data.value)}
                  id={index + "Course"}
                  title=""
                  maxLength="100"
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Course) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Course cannot be empty
                  </p>
                ) : null}
              </div>
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel ">Specialisation</label>
                <input
                  className={"form-control z-depth-3"}
                  value={el.Specialization || ""}
                  type="text"
                  name="Specialization"
                  onChange={(event) => EducationDetailsHandler(event, data.value)}
                  id={index + "Specialization"}
                  title=""
                  maxLength="100"
                />
              </div>
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel ">
                  {data.isMandatory || isRequired ? <span className="requiredText">*</span> : null}
                  {!ERPUtils.isNullorWhiteSpace(el.Status)
                    ? el.Status.label === "Pursuing"
                      ? "Year of Registration"
                      : "Year of Completion"
                    : "Year of Completion"}
                </label>
                <Select
                  className={isMandatory && ERPUtils.isNullorWhiteSpace(el.YearOfComp) ? "invalidSelect z-depth-3" : "formSelect z-depth-3"}
                  value={el.YearOfComp}
                  onChange={(selected) => EducationalDetailsDropDownHandler(selected, index, "YearOfComp", "", "", "", data.value, true)}
                  options={YearsDropDownData}
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.YearOfComp) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Year cannot be empty
                  </p>
                ) : null}
              </div>
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel ">
                  {(data.isMandatory || isRequired) && !data.isStatusDisplay ? <span className="requiredText">*</span> : null}
                  {!ERPUtils.isNullorWhiteSpace(el.Status) ? (el.Status.label === "Pursuing" ? "Current status" : "Grade/Percentage") : "Grade/Percentage"}
                </label>
                <input
                  className={
                    isMandatory && ERPUtils.isNullorWhiteSpace(el.Percentage) && !data.isStatusDisplay
                      ? "form-control invalid z-depth-3"
                      : "form-control z-depth-3"
                  }
                  value={el.Percentage || ""}
                  type="text"
                  name="Percentage"
                  onChange={(event) =>
                    EducationDetailsHandler(
                      event,
                      data.value,
                      "grade"
                      // !ERPUtils.isNullorWhiteSpace(el.Status) ? el.Status.label === 'Pursuing' ? 'text' : 'number' : "number"
                    )
                  }
                  title=""
                  id={index + "Percentage"}
                  maxLength="50"
                  onBlur={() =>
                    !ERPUtils.isNullorWhiteSpace(el.Status)
                      ? el.Status.label === "Pursuing"
                        ? null
                        : (event) => checkDecimal(event, data.value)
                      : (event) => checkDecimal(event, data.value)
                  }
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Percentage) && !data.isStatusDisplay ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    {el.Status.label === "Pursuing" ? "Current Status cannot be empty" : "Percentage cannot be empty"}
                  </p>
                ) : null}
              </div>

              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Country</label>
                <Select
                  className={isMandatory && ERPUtils.isNullorWhiteSpace(el.countryId) ? "invalid z-depth-3" : "z-depth-3"}
                  value={typeof el.countryId === "object" ? el.countryId : ERPUtils.getSelect2ItemByID(countries, el.countryId)}
                  options={countries}
                  title={data.label}
                  id={index + "countryId"}
                  onChange={(selected) => EducationDetailsSelectHandler(selected, data?.value, index, "countryId", data?.label, data)}
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.countryId) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Country cannot be empty
                  </p>
                ) : null}
              </div>
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} State</label>
                {ERPUtils.isNullorWhiteSpace(el.stateId) &&
                  (ERPUtils.isUndefinedOrNull(states[parseInt(el?.countryId)]) || ERPUtils.isNullOrEmpty(states[parseInt(el?.countryId)])) ? (
                  <div style={{ display: "inline" }}>
                    <input
                      className={isMandatory && ERPUtils.isNullorWhiteSpace(el.stateOther) ? " invalid form-control z-depth-3" : "form-control z-depth-3"}
                      value={el.stateOther || ""}
                      name="stateOther"
                      type="text"
                      id={index + "stateOther"}
                      title={data?.label}
                      onChange={(event) => EducationDetailsHandler(event, data.value)}
                      maxLength="100"
                    />
                    {/* <i
									className="fa fa-times"
									style={{
										marginLeft: '5px',
										position: 'absolute',
										top: '12px',
										right: '-20px'
									}}
									onClick={() => GenerateRemovePopup('currStatePopup')}
								/> */}
                  </div>
                ) : (
                  <Select
                    className={isMandatory && ERPUtils.isNullorWhiteSpace(el.stateId) ? "invalid z-depth-3" : "z-depth-3"}
                    options={states[el?.countryId]}
                    title={data.label}
                    id={index + "stateId"}
                    value={typeof el.stateId === "object" ? el.stateId : ERPUtils.getSelect2ItemByID(states[el?.countryId], el.stateId)}
                    onChange={(selected) => EducationDetailsSelectHandler(selected, data?.value, index, "stateId", data?.label, data)}
                  />
                )}
                {isMandatory && ERPUtils.isNullOrEmpty(el.stateOther) && ERPUtils.isNullOrEmpty(el.stateId) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    State cannot be empty
                  </p>
                ) : null}
              </div>

              {/* //!BOARD OR UNIVERSITY SELECT DROPDOWN */}
              {/* <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Board/University</label>
                <CreatableSelect
                  value={ERPUtils.isNullorWhiteSpace(el.erpBoardOrUniversity) ? { value: el.Board, label: el.Board } : el.erpBoardOrUniversity}
                  onChange={(selected) => EducationDetailsSelectHandler(selected, data?.value, index, "Board", data?.label)}
                  options={!ERPUtils.isUndefinedOrNull(boardList[data?.value]) ? boardList[data?.value][index] : []}
                  isClearable
                  allowCreateWhileLoading
                  // formatCreateLabel={(inputValue) => {
                  //   EducationDetailsSelectHandler({ value: inputValue, label: inputValue }, data?.value, index, "Board", data?.label);
                  //   return "Loading...";
                  // }}
                  components={{ NoOptionsMessage }}
                />

                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Board) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Board cannot be empty
                  </p>
                ) : null}
              </div>

              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Institute</label>
                <CreatableSelect
                  // value={el?.erpInstitute}
                  value={ERPUtils.isNullorWhiteSpace(el?.erpInstitute) ? { value: el.Institute, label: el.Institute } : el.erpInstitute}
                  onInputChange={(value) => {
                    if (!ERPUtils.isNullorWhiteSpace(value)) getBoardOrInstitueList(value, data?.value, index, "Institute", data?.label, data, false);
                  }}
                  onChange={(selected) =>
                    EducationDetailsSelectHandler({ value: selected?.label, label: selected?.label }, data?.value, index, "Institute", data?.label)
                  }
                  // options={!ERPUtils.isUndefinedOrNull(institutionList[data?.value]) ? institutionList[data?.value][index] : []}
                  isClearable
                  // allowCreateWhileLoading
                  // formatCreateLabel={(inputValue) => {
                  //   EducationDetailsSelectHandler({ value: inputValue, label: inputValue }, data?.value, index, "Institute", data?.label);
                  //   return "Loading...";
                  // }}
                  components={{ NoOptionsMessage }}
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Institute) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Institute cannot be empty
                  </p>
                ) : null}
              </div> */}
              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Board/University</label>
                <CreatableSelect
                  value={ERPUtils.isNullorWhiteSpace(el.erpBoardOrUniversity) ? { value: el.Board, label: el.Board } : el.erpBoardOrUniversity}
                  onCreateOption={(inputValue) => {
                    if (inputValue.length > 100) {
                      toast.warning("State Board name cannot exceed 100 characters.")
                      return;
                    }
                    const newOption = { value: inputValue, label: inputValue };
                    EducationDetailsSelectHandler(
                      newOption, data?.value, index, "Board", data?.label
                    )
                  }}
                  onChange={(selected) => EducationDetailsSelectHandler(selected, data?.value, index, "Board", data?.label)}
                  options={!ERPUtils.isUndefinedOrNull(boardList[data?.value]) ? boardList[data?.value][index] : []}
                  isClearable
                  allowCreateWhileLoading
                  // formatCreateLabel={(inputValue) => {
                  //   EducationDetailsSelectHandler({ value: inputValue, label: inputValue }, data?.value, index, "Board", data?.label);
                  //   return "Loading...";
                  // }}
                  components={{ NoOptionsMessage }}
                />

                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Board) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Board cannot be empty
                  </p>
                ) : null}
              </div>

              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">{data.isMandatory || isRequired ? <span className="requiredText">*</span> : null} Institute</label>
                <CreatableSelect
                  value={ERPUtils.isNullorWhiteSpace(el?.erpInstitute) ? { value: el.Institute, label: el.Institute } : el.erpInstitute}
                  onInputChange={(value) => {
                    if (!ERPUtils.isNullorWhiteSpace(value)) getBoardOrInstitueList(value, data?.value, index, "Institute", data?.label, data, false);
                  }}
                  onChange={(selected) =>
                    EducationDetailsSelectHandler({ value: selected?.label, label: selected?.label }, data?.value, index, "Institute", data?.label)
                  }
                  onCreateOption={(inputValue) => {
                    if (inputValue.length > 100) {
                      toast.warning("Institute name cannot exceed 100 characters.")
                      return;
                    }
                    const newOption = { value: inputValue, label: inputValue };
                    EducationDetailsSelectHandler(
                      newOption,
                      data?.value,
                      index,
                      "Institute",
                      data?.label
                    );
                  }}
                  isClearable
                  // allowCreateWhileLoading
                  // formatCreateLabel={(inputValue) => {
                  //   EducationDetailsSelectHandler({ value: inputValue, label: inputValue }, data?.value, index, "Institute", data?.label);
                  //   return "Loading...";
                  // }}
                  components={{ NoOptionsMessage }}
                />
                {isMandatory && ERPUtils.isNullorWhiteSpace(el.Institute) ? (
                  <p className="ValidationError">
                    <i className="fa fa-warning warningIcon" />
                    Institute cannot be empty
                  </p>
                ) : null}
              </div>

              <div className="col-md-4 col-lg-3 col-sm-6">
                <label className="formRenderlabel">
                  Document
                  <span className="upload-accepted-format-indication">({processCodeData[0]?.fileTypeList.join(",")})</span>
                </label>
                <UploadFile
                  callback={getUploadData}
                  data={el?.Documents}
                  isMulti
                  keyList={processCodeData}
                  id={uploadProcessCode}
                  otherParams={{ parent: data.value, id: index }}
                />
                <br />
                <span className="upload-accepted-format-indication">File size limit: less than 1024kb</span>
              </div>
              {index >= 1 ? (
                <div className={data.isStatusDisplay ? "col-md-12" : "col-md-12"}>
                  <button
                    type="button"
                    className="RemoveLinkButton pull-right"
                    onClick={() => GenerateRemovePopup("EducationPopup", index, "Education", data.value)}
                    id={index}
                    title=""
                  >
                    <i className="fa fa-trash RemoveIcon" />
                    Remove
                  </button>
                </div>
              ) : null}
            </div>
          </div>
        );
      })}
      {data.isAddMore ? (
        <div className="row">
          <div className="col-md-12">
            <button type="button" className="formLinkButton pull-right" title="" onClick={() => addComponent("Education", data.value, true)}>
              <span className="fa fa-plus formAddIcon" />
              Add More ({data.label})
            </button>
          </div>
        </div>
      ) : null}
      <div className="appDivider" />
      {/* {
				openView.popupOpen ? (
					<ImagesPopup
						open={openView.popupOpen}
						close={ClosePopup}
						Imgdata={compData}
						imageRemoveHandler={imageRemoveHandler}
						currentIndex={openView.currentIndex}
						compName={data.value}
						openImageInTab={openImageInTab}
						isFromEducation={true}
					/>
				) : null
			} */}
    </div>
  );
};

export default TenthComp;
